import { FiX } from "solid-icons/fi";
import { Empty } from '@biketravel/solid-ui';

export const EventEmpty = () => (
  <Empty
    icon={<FiX stroke-width={1}/>}
    title='Поездки не найдены'
    text='По выбранным параметрам поездки не найдены или отсутствуют. Вы можете запланировать свою поездку на любое удобное для вас время.'
  />
)